import React from 'react';
import {Loading} from '@enos/dpl';
import {inject, observer} from 'mobx-react';
import {init, collectResource} from '@enos/dpl/lib/locale/localeUtils';
import {Switch, Route, withRouter, Prompt} from 'react-router-dom';
import {USER_PERMISSION_TYPE, REDIRECT_TO_HOME, REDIRECT_TO_404, REDIRECT_TO_SELECT_COMPANY} from '../../utils/constants';
import EventTarget from '../../utils/eventTarget';
import NotFound from '~/routes/404';
import AuthenticatedRoute from '~/components/AuthenticatedRoute';
import {MediaQuery} from '~/components/Responsive';

import '../../assets/css/style.less';

init(collectResource(require.context('../../locale', false, /\.js$/)));

@inject('sessionStore', 'userStore')
@withRouter
@observer
class BaseRoute extends React.Component {
  constructor(props) {
    super(props);
    this.eventTarget = new EventTarget();
    this.eventTarget.subEvent(REDIRECT_TO_HOME, this, 'redirectToHomePage');
    this.eventTarget.subEvent(REDIRECT_TO_404, this, 'redirectToNotFound');
    this.eventTarget.subEvent(REDIRECT_TO_SELECT_COMPANY, this, 'redirectToCompanySelect');
    window.eventTarget = this.eventTarget;
  }

  componentDidMount() {
    const {sessionStore, location, routes} = this.props;
    // 如果 path 又/modal/ 开头，表示是临时生产的路由刷新的，此时进入首页。
    if (/^\/modal\//.test(location.pathname)) {
      this.redirectToHomePage();
    }
    sessionStore.getLionConfiguration();

    if (
      location.pathname !== '/404'
          && !/^\/site\//.test(location.pathname)
          && !routes.some(({authLevel, path}) => authLevel.includes(USER_PERMISSION_TYPE.ANONYMOUS) && path === location.pathname)
    ) {
      sessionStore.getSession();
    } else {
      sessionStore.clearLoading();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTop = 0;
    }
  }

      renderRoute = (route, index) => {
        if (route.authLevel.includes(USER_PERMISSION_TYPE.ANONYMOUS)) {
          return <Route {...{[['key'][0]]: index}} {...route} />;
        }

        return <AuthenticatedRoute {...{[['key'][0]]: index}} {...route} />;
      };

      render() {
        const {routes, sessionStore, location} = this.props;
        return [
          <Prompt {...{[['key'][0]]: 'prompt'}} message={(l, action) => action} />,
          <MediaQuery {...{[['key'][0]]: 'media-query'}} forceDesktop={/^\/admin\//.test(location.pathname)}>
            {sessionStore.isLoading ? (
              <Loading visible />
            ) : (
              <Switch>
                {routes.map(this.renderRoute)}
                <Route component={NotFound} />
              </Switch>
            )}
          </MediaQuery>
        ];
      }

      redirectToHomePage() {
        const {history} = this.props;
        history.push('/');
      }

      redirectToNotFound() {
        this.props.history.push('/404');
      }

      redirectToCompanySelect() {
        this.props.history.push('/company-select');
      }
}

export default BaseRoute;
